import { useLocation, useNavigate } from "react-router-dom";
import { Users, Briefcase, Building2, Plug, Bot, Shield } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function AdminNavTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab based on current route
  const getActiveTab = () => {
    if (location.pathname.startsWith("/admin/users")) return "people";
    if (location.pathname.startsWith("/admin/jobs")) return "jobs";
    if (location.pathname.startsWith("/admin/companies")) return "companies";
    if (location.pathname.startsWith("/admin/integrations")) return "integrations";
    if (location.pathname.startsWith("/admin/ai-tools")) return "ai-tools";
    if (location.pathname.startsWith("/admin/voice-security")) return "voice-security";
    return "people";
  };

  const handleTabChange = (value: string) => {
    switch (value) {
      case "people":
        navigate("/admin/users");
        break;
      case "jobs":
        navigate("/admin/jobs");
        break;
      case "companies":
        navigate("/admin/companies");
        break;
      case "integrations":
        navigate("/admin/integrations");
        break;
      case "ai-tools":
        navigate("/admin/ai-tools");
        break;
      case "voice-security":
        navigate("/admin/voice-security");
        break;
    }
  };

  return (
    <div className="flex justify-center">
      <Tabs value={getActiveTab()} onValueChange={handleTabChange}>
        <TabsList className="bg-background border rounded-full p-1 shadow-sm h-11">
          <TabsTrigger 
            value="people" 
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Users className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">People</span>
          </TabsTrigger>
          <TabsTrigger 
            value="jobs"
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Briefcase className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Jobs</span>
          </TabsTrigger>
          <TabsTrigger 
            value="companies"
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Building2 className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Companies</span>
          </TabsTrigger>
          <TabsTrigger 
            value="integrations"
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Plug className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Integrations</span>
          </TabsTrigger>
          <TabsTrigger 
            value="ai-tools"
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Bot className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">AI Tools</span>
          </TabsTrigger>
          <TabsTrigger 
            value="voice-security"
            className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
          >
            <Shield className="h-4 w-4 mr-2" />
            <span className="hidden sm:inline">Voice Security</span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
